module.exports = __webpack_public_path__ + "static/media/ic_categories_furniture.2d88f09d.svg";